<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <p>广州寄件人</p>
          <el-form-item label="寄件人">
            <el-input v-model="form.gz_sender.name"></el-input>
          </el-form-item>
          <!--<el-form-item label="寄件公司">-->
          <!--<el-input v-model="form.gz_sender.company"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="寄件地址">-->
          <!--<el-input v-model="form.gz_sender.detail"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="手机">-->
          <!--<el-input v-model="form.gz_sender.mobile"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="电话">
            <el-input v-model="form.gz_sender.phone"></el-input>
          </el-form-item>

          <p>杭州寄件人</p>
          <el-form-item label="寄件人">
            <el-input v-model="form.hz_sender.name"></el-input>
          </el-form-item>
          <!--<el-form-item label="寄件公司">-->
          <!--<el-input v-model="form.hz_sender.company" ></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="寄件地址">-->
          <!--<el-input v-model="form.hz_sender.detail"></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="手机">-->
          <!--<el-input v-model="form.hz_sender.mobile"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="电话">
            <el-input v-model="form.hz_sender.phone"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global.vue";
import HeaderTabs from "./components/HeaderTabs.vue";

export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        gz_sender: {
          phone: "020-81747343",
          name: "蒋小爱",
          detail: "广州荔湾区十三行厂家源头货",
          province: "广东省",
        },
        hz_sender: {
          phone: "020-81747343",
          name: "蒋小爱",
          detail: "杭州江干区厂家源头货",
          province: "浙江省",
        },
        shipping_companies: [
          {
            min: 0,
            max: 0,
            shipping_company: "",
          },
        ],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/Setting",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    removeShipping(item) {
      const index = this.form.shipping_companies.indexOf(item);
      if (index !== -1) {
        this.form.shipping_companies.splice(index, 1);
      }
    },
    addShipping() {
      this.form.shipping_companies.push({
        key: Date.now(),
        min: 0,
        max: 0,
        shipping_company: "",
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
        }
      });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.shipping_company = res.data.data.shipping_company;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/WavePickingSetting.vue